import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/root-reducer';
import { initializePaddle } from '../../utils';

interface UsePaddleIntegrationWithConfigProps {
  enable?: boolean;
  token?: string;
  onError?: (error: any) => void;
}

const usePaddleIntegrationWithConfig = ({
  enable = true,
  onError,
}: UsePaddleIntegrationWithConfigProps = {}) => {
  const token = process.env.REACT_APP_PADDLE_TOKEN;

  const homeSubscription = useSelector(
    (state: RootState) => state.home?.subscription,
  );

  const customerId = useMemo(() => {
    if (
      homeSubscription?.planProvider === 'paddle' &&
      homeSubscription?.customerId
    ) {
      return homeSubscription.customerId;
    }

    return '';
  }, [homeSubscription]);

  useEffect(() => {
    if (!enable) return;

    try {
      if (token) {
        initializePaddle(token, customerId || '');
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error('Error initializing Paddle:', error);
      }
      onError?.(error);
    }
  }, [enable, token, customerId, onError]);

  return null;
};

export default usePaddleIntegrationWithConfig;
